/* Bambu Earth Pro — Bulk Order Form controller
   Hydrates a server-rendered section: handles qty steppers, filter chips,
   side-nav active tracking, summary recalculation, and Shopify /cart/add.js
   submission with PO/Need-By cart attributes. */

(function () {
  'use strict';

  var STORAGE_KEY = 'bambu-pro-order-draft';
  var FILTER_MATCH = {
    all:     function () { return true; },
    backbar: function (v) { return v.type === 'Backbar' || v.type === 'Backbar/Retail'; },
    retail:  function (v) { return v.type === 'Retail'  || v.type === 'Backbar/Retail'; },
    trial:   function (v) { return v.type === 'Deluxe Trial'; }
  };

  function usd(n) {
    return '$' + Number(n).toFixed(2).replace(/\.00$/, '');
  }

  function initBulkOrderForm(root) {
    if (!root || root.dataset.bulkOrderInitialized === 'true') return;
    root.dataset.bulkOrderInitialized = 'true';

    var dataEl = root.querySelector('[data-bulk-order-form-data]');
    if (!dataEl) {
      console.warn('[bulk-order-form] missing data blob');
      return;
    }
    var data;
    try { data = JSON.parse(dataEl.textContent); }
    catch (e) { console.error('[bulk-order-form] bad data blob', e); return; }

    var catalog = data.catalog || [];
    var variantIds = data.variantIds || {};
    var account = data.account || {};
    var freeShipThreshold = Number(data.freeShipThreshold) || 75;

    // Build a flat index: sku -> { msrp, pro, type, productName, categoryId }
    var skuIndex = {};
    for (var ci = 0; ci < catalog.length; ci++) {
      var cat = catalog[ci];
      for (var pi = 0; pi < cat.products.length; pi++) {
        var p = cat.products[pi];
        for (var vi = 0; vi < p.variants.length; vi++) {
          var v = p.variants[vi];
          skuIndex[v.sku] = {
            sku: v.sku,
            type: v.type,
            size: v.size,
            msrp: v.msrp,
            pro: v.pro,
            productName: p.name,
            categoryId: cat.id,
            categoryName: cat.name
          };
        }
      }
    }

    // State
    var state = {
      qtys: {},
      poNumber: '',
      shipDate: '',
      filter: 'all',
      activeCat: catalog[0] ? catalog[0].id : null,
      submitStatus: 'idle' // 'idle' | 'loading' | 'error'
    };

    // Rehydrate draft
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (raw) {
        var saved = JSON.parse(raw);
        if (saved && typeof saved === 'object') {
          if (saved.qtys && typeof saved.qtys === 'object') state.qtys = saved.qtys;
          if (typeof saved.poNumber === 'string') state.poNumber = saved.poNumber;
          if (typeof saved.shipDate === 'string') state.shipDate = saved.shipDate;
        }
      }
    } catch (e) {}

    // ---------- DOM references ----------
    var els = {
      poInput: root.querySelector('[data-field="po-number"]'),
      shipInput: root.querySelector('[data-field="ship-date"]'),
      summary: root.querySelector('[data-summary]'),
      summaryItems: root.querySelector('[data-summary-items]'),
      summaryTotal: root.querySelector('[data-summary-total]'),
      shipLabel: root.querySelector('[data-ship-label]'),
      shipBar: root.querySelector('[data-ship-bar]'),
      submitBtn: root.querySelector('[data-submit-btn]'),
      submitLabel: root.querySelector('[data-submit-label]'),
      errorBanner: root.querySelector('[data-error-banner]'),
      errorMessage: root.querySelector('[data-error-message]'),
      errorDismiss: root.querySelector('[data-error-dismiss]'),
      chips: root.querySelectorAll('[data-filter-chip]'),
      catLinks: root.querySelectorAll('[data-cat-link]'),
      catSections: root.querySelectorAll('[data-cat]'),
      rows: root.querySelectorAll('[data-row]')
    };

    // ---------- Pure helpers ----------
    function computeStats() {
      var items = 0, total = 0;
      for (var sku in state.qtys) {
        var q = state.qtys[sku] || 0;
        if (q <= 0) continue;
        var v = skuIndex[sku];
        if (!v) continue;
        items += q;
        total += q * v.pro;
      }
      return { items: items, total: total };
    }

    function categoryItemCount(catId) {
      var n = 0;
      var cat = null;
      for (var i = 0; i < catalog.length; i++) {
        if (catalog[i].id === catId) { cat = catalog[i]; break; }
      }
      if (!cat) return 0;
      for (var pi = 0; pi < cat.products.length; pi++) {
        for (var vi = 0; vi < cat.products[pi].variants.length; vi++) {
          var v = cat.products[pi].variants[vi];
          n += state.qtys[v.sku] || 0;
        }
      }
      return n;
    }

    function persistDraft() {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify({
          qtys: state.qtys, poNumber: state.poNumber, shipDate: state.shipDate
        }));
      } catch (e) {}
    }

    // ---------- Rendering ----------
    function renderRow(row) {
      var sku = row.getAttribute('data-row');
      var v = skuIndex[sku];
      if (!v) return;
      var q = state.qtys[sku] || 0;

      // Row state
      row.classList.toggle('is-filled', q > 0);

      // Filter visibility
      var matches = FILTER_MATCH[state.filter](v);
      row.classList.toggle('is-hidden', !matches);

      // Qty input
      var input = row.querySelector('[data-qty-input]');
      if (input && document.activeElement !== input) {
        input.value = q === 0 ? '' : String(q);
      }

      // Decrement disabled state
      var decBtn = row.querySelector('[data-qty-dec]');
      if (decBtn) decBtn.disabled = q <= 0;

      // Line total
      var totalCell = row.querySelector('[data-line-total]');
      if (totalCell) {
        if (q === 0) {
          totalCell.textContent = '—';
          totalCell.classList.add('empty');
        } else {
          totalCell.textContent = usd(q * v.pro);
          totalCell.classList.remove('empty');
        }
      }
    }

    function renderCategoryStats() {
      var catStats = root.querySelectorAll('[data-cat-stats]');
      for (var i = 0; i < catStats.length; i++) {
        var node = catStats[i];
        var catId = node.getAttribute('data-cat-stats');
        var n = 0, total = 0;
        var cat = null;
        for (var j = 0; j < catalog.length; j++) if (catalog[j].id === catId) { cat = catalog[j]; break; }
        if (cat) {
          for (var pi = 0; pi < cat.products.length; pi++) {
            for (var vi = 0; vi < cat.products[pi].variants.length; vi++) {
              var v = cat.products[pi].variants[vi];
              var q = state.qtys[v.sku] || 0;
              if (q > 0) { n += q; total += q * v.pro; }
            }
          }
        }
        if (n > 0) {
          node.innerHTML = '<span class="qty-summary">' + n + ' ' +
            (n === 1 ? 'unit' : 'units') + ' · ' + usd(total) + '</span>';
        } else {
          node.innerHTML = '<span>—</span>';
        }
      }
    }

    function renderSideNavCounts() {
      for (var i = 0; i < els.catLinks.length; i++) {
        var link = els.catLinks[i];
        var catId = link.getAttribute('data-cat-link');
        var n = categoryItemCount(catId);
        var countEl = link.querySelector('.count');
        if (countEl) {
          if (n > 0) { countEl.textContent = n; countEl.hidden = false; }
          else { countEl.hidden = true; }
        }
        link.classList.toggle('is-active', catId === state.activeCat);
      }
    }

    function renderChips() {
      for (var i = 0; i < els.chips.length; i++) {
        var chip = els.chips[i];
        var key = chip.getAttribute('data-filter-chip');
        chip.classList.toggle('is-active', key === state.filter);
      }
    }

    function renderSummary() {
      var s = computeStats();

      if (els.summaryItems) els.summaryItems.textContent = String(s.items);
      if (els.summaryTotal) els.summaryTotal.textContent = usd(s.total);

      var pct = Math.min(100, (s.total / freeShipThreshold) * 100);
      var remaining = Math.max(0, freeShipThreshold - s.total);
      if (els.shipBar) els.shipBar.style.width = pct + '%';
      if (els.shipLabel) {
        if (s.total >= freeShipThreshold) {
          els.shipLabel.textContent = 'Free shipping unlocked';
          els.shipLabel.classList.add('met');
        } else {
          els.shipLabel.textContent = usd(remaining) + ' to free shipping';
          els.shipLabel.classList.remove('met');
        }
      }

      if (els.submitBtn) {
        var isLoading = state.submitStatus === 'loading';
        els.submitBtn.disabled = s.items === 0 || isLoading;
        els.submitBtn.classList.toggle('is-loading', isLoading);
        if (els.submitLabel) {
          if (isLoading) {
            els.submitLabel.innerHTML = 'Adding to cart…<span class="spinner"></span>';
          } else if (s.items === 0) {
            els.submitLabel.textContent = 'Add items to submit';
          } else {
            els.submitLabel.innerHTML = 'Submit &amp; load cart <span class="arr">→</span>';
          }
        }
      }
    }

    function renderAll() {
      for (var i = 0; i < els.rows.length; i++) renderRow(els.rows[i]);
      renderCategoryStats();
      renderSideNavCounts();
      renderChips();
      renderSummary();
    }

    // ---------- Mutations ----------
    function setQty(sku, n) {
      n = Math.max(0, Math.floor(Number(n) || 0));
      if (n === 0) delete state.qtys[sku];
      else state.qtys[sku] = n;
      persistDraft();
      // Targeted re-render
      var row = root.querySelector('[data-row="' + sku + '"]');
      if (row) renderRow(row);
      renderCategoryStats();
      renderSideNavCounts();
      renderSummary();
    }

    function setFilter(key) {
      if (!FILTER_MATCH[key]) return;
      state.filter = key;
      // Update row visibility only
      for (var i = 0; i < els.rows.length; i++) {
        var row = els.rows[i];
        var sku = row.getAttribute('data-row');
        var v = skuIndex[sku];
        if (!v) continue;
        row.classList.toggle('is-hidden', !FILTER_MATCH[key](v));
      }
      renderChips();
    }

    function setActiveCat(id) {
      if (id === state.activeCat) return;
      state.activeCat = id;
      renderSideNavCounts();
    }

    // ---------- Wiring ----------
    // Qty inputs (delegation on the form area)
    root.addEventListener('click', function (e) {
      var dec = e.target.closest('[data-qty-dec]');
      var inc = e.target.closest('[data-qty-inc]');
      if (dec) {
        var row = dec.closest('[data-row]');
        var sku = row && row.getAttribute('data-row');
        if (sku) setQty(sku, (state.qtys[sku] || 0) - 1);
        return;
      }
      if (inc) {
        var row2 = inc.closest('[data-row]');
        var sku2 = row2 && row2.getAttribute('data-row');
        if (sku2) setQty(sku2, (state.qtys[sku2] || 0) + 1);
        return;
      }
    });

    root.addEventListener('input', function (e) {
      var input = e.target.closest('[data-qty-input]');
      if (!input) return;
      var row = input.closest('[data-row]');
      var sku = row && row.getAttribute('data-row');
      if (!sku) return;
      var n = input.value === '' ? 0 : Math.max(0, parseInt(input.value, 10) || 0);
      setQty(sku, n);
    });

    root.addEventListener('focusin', function (e) {
      var input = e.target.closest('[data-qty-input]');
      if (input) input.select();
    });

    // Filter chips
    for (var i = 0; i < els.chips.length; i++) {
      (function (chip) {
        chip.addEventListener('click', function () {
          setFilter(chip.getAttribute('data-filter-chip'));
        });
      })(els.chips[i]);
    }

    // Side-nav links
    for (var j = 0; j < els.catLinks.length; j++) {
      (function (link) {
        link.addEventListener('click', function () {
          var id = link.getAttribute('data-cat-link');
          var target = root.querySelector('[data-cat="' + id + '"]');
          if (target) {
            var y = target.getBoundingClientRect().top + window.scrollY - 90;
            window.scrollTo({ top: y, behavior: 'smooth' });
            setActiveCat(id);
          }
        });
      })(els.catLinks[j]);
    }

    // Meta inputs
    if (els.poInput) {
      els.poInput.value = state.poNumber;
      els.poInput.addEventListener('input', function () {
        state.poNumber = els.poInput.value;
        persistDraft();
      });
    }
    if (els.shipInput) {
      els.shipInput.value = state.shipDate;
      els.shipInput.addEventListener('input', function () {
        state.shipDate = els.shipInput.value;
        persistDraft();
      });
    }

    // Scroll spy for active category
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var fromTop = 200;
        var best = catalog[0] ? catalog[0].id : null;
        for (var i = 0; i < els.catSections.length; i++) {
          var sec = els.catSections[i];
          var top = sec.getBoundingClientRect().top;
          if (top - fromTop <= 0) best = sec.getAttribute('data-cat');
        }
        if (best) setActiveCat(best);
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });

    // Error dismiss
    if (els.errorDismiss) {
      els.errorDismiss.addEventListener('click', function () {
        state.submitStatus = 'idle';
        if (els.errorBanner) els.errorBanner.hidden = true;
      });
    }

    // Submit
    function showError(msg) {
      state.submitStatus = 'error';
      if (els.errorMessage) els.errorMessage.textContent = msg;
      if (els.errorBanner) els.errorBanner.hidden = false;
      renderSummary();
    }

    function shakeSubmit() {
      if (!els.submitBtn) return;
      els.submitBtn.classList.add('shake');
      setTimeout(function () {
        if (els.submitBtn) els.submitBtn.classList.remove('shake');
      }, 400);
    }

    if (els.submitBtn) {
      els.submitBtn.addEventListener('click', function () {
        var stats = computeStats();
        if (stats.items === 0) { shakeSubmit(); return; }

        // Build items
        var items = [];
        var unmapped = [];
        for (var sku in state.qtys) {
          var q = state.qtys[sku];
          if (!q || q <= 0) continue;
          var id = variantIds[sku];
          if (id == null) { unmapped.push(sku); continue; }
          items.push({
            id: id,
            quantity: q,
            properties: state.poNumber ? { 'PO Number': state.poNumber } : undefined
          });
        }

        if (items.length === 0) {
          showError('None of the selected SKUs are mapped to Shopify variants yet.');
          return;
        }
        if (unmapped.length > 0) {
          console.warn('[bulk-order-form] unmapped SKUs (skipped):', unmapped);
        }

        state.submitStatus = 'loading';
        if (els.errorBanner) els.errorBanner.hidden = true;
        renderSummary();

        var attrPromise = Promise.resolve();
        if (state.poNumber || state.shipDate) {
          attrPromise = fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              attributes: {
                'PO Number':    state.poNumber || '',
                'Need-By Date': state.shipDate || '',
                'Pro Account':  account.name || '',
                'Account Rep':  account.rep || ''
              },
              note: state.poNumber ? 'Pro Order — PO ' + state.poNumber : 'Pro Order'
            })
          }).catch(function () { /* non-fatal */ });
        }

        attrPromise.then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
            body: JSON.stringify({ items: items })
          });
        }).then(function (res) {
          if (!res.ok) {
            return res.json().catch(function () { return { description: res.statusText }; })
              .then(function (err) {
                throw new Error(err && (err.description || err.message) || ('Shopify returned ' + res.status));
              });
          }
          return res.json();
        }).then(function () {
          try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
          window.location.href = '/cart';
        }).catch(function (e) {
          showError(e && e.message ? e.message : 'Couldn’t reach Shopify. Your draft is saved — try again.');
        });
      });
    }

    // Initial paint
    renderAll();
  }

  function boot() {
    var roots = document.querySelectorAll('.bulk-order-form');
    for (var i = 0; i < roots.length; i++) initBulkOrderForm(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init when a section is reloaded in the theme editor
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('.bulk-order-form');
    if (root) initBulkOrderForm(root);
  });
})();
